import React, { useEffect, useRef, useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Box,
    CircularProgress,
    Typography,
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import Axios from "axios";
import { getAuthHeader } from "../../utils/authToken";
import { exportElementToPdf } from "../../utils/exportElementPdf";
import EttReportView from "../ettReports/EttReportView";

// Renders a student's ETT test-session report (the same view as the ETT Reports page) in a
// dialog — opened from a score cell in PrepExamMatrix. Fetches the report on open.
const PrepTestReportModal = ({ open, onClose, ettUserId, testId, examTitle, studentName }) => {
    const [report, setReport] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const viewRef = useRef();

    useEffect(() => {
        if (!open || !ettUserId || !testId) return undefined;
        let cancelled = false;
        setLoading(true);
        setError(false);
        setReport(null);
        Axios.get(
            `${process.env.REACT_APP_URL}/api/v1/ett-reports/users/${ettUserId}/tests/${testId}/report`,
            { headers: { Authorization: getAuthHeader() } }
        )
            .then((res) => { if (!cancelled) setReport(res.data); })
            .catch((e) => { if (!cancelled) { console.error("Prep test report error:", e); setError(true); } })
            .finally(() => { if (!cancelled) setLoading(false); });
        return () => { cancelled = true; };
    }, [open, ettUserId, testId]);

    const download = () =>
        report && exportElementToPdf(viewRef.current, `ETT_Report_${studentName || ""}_${examTitle || ""}.pdf`);

    return (
        <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth scroll="paper">
            <DialogTitle>
                {examTitle || "Test report"}{studentName ? ` — ${studentName}` : ""}
            </DialogTitle>
            <DialogContent dividers sx={{ backgroundColor: "#fafafa" }}>
                {loading ? (
                    <Box display="flex" justifyContent="center" py={5}><CircularProgress /></Box>
                ) : error ? (
                    <Typography color="error" sx={{ py: 3 }}>Couldn&apos;t load the report. Please try again.</Typography>
                ) : report ? (
                    <EttReportView ref={viewRef} report={report} />
                ) : (
                    <Typography color="text.secondary" sx={{ py: 3 }}>No report available.</Typography>
                )}
            </DialogContent>
            <DialogActions>
                {report && <Button startIcon={<DownloadIcon />} onClick={download}>Download PDF</Button>}
                <Button onClick={onClose}>Close</Button>
            </DialogActions>
        </Dialog>
    );
};

export default PrepTestReportModal;
